import React, { FC } from 'react'
import { ServerExperiments } from '@/experimentation'
import { ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { PhaseSlug, SweepstakeObject } from '@/types/codegen-federation'
import { useHomesteadSeriesGiveawayConfig } from '@/views/GuildGiveawayView/useHomesteadSeriesGiveawayConfig'
import { GiveawayLayout } from './../PreSales/PreSalesGiveawayView/GiveawayLayout'
import { GiveawayContextProvider } from './../PreSales/PreSalesGiveawayView/context/GiveawayContext'
import { GiveawayTypographyProvider } from './../PreSales/PreSalesGiveawayView/context/GiveawayTypographyProvider'

interface Props {
  theatricalSlug: string
  tickets?: ShopifyProductWithBundles[]
  sweepstake: SweepstakeObject
  phase: PhaseSlug | null
  experiments?: ServerExperiments
  hasUser?: boolean
}

export const GuildGiveawayView: FC<Props> = ({ tickets, theatricalSlug, phase, sweepstake, experiments, hasUser }) => {
  const giveawayData = useHomesteadSeriesGiveawayConfig()

  if (!giveawayData) return null

  return (
    <GiveawayTypographyProvider theatricalSlug={theatricalSlug}>
      <GiveawayContextProvider
        theatricalSlug={theatricalSlug}
        tickets={tickets}
        sweepstake={sweepstake}
        phase={phase}
        giveawayData={giveawayData}
        experiments={experiments}
      >
        <GiveawayLayout hasUser={hasUser} />
      </GiveawayContextProvider>
    </GiveawayTypographyProvider>
  )
}
